var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgEmptyInbox = function SvgImgEmptyInbox(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M36 42h9v25a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1V42h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M36.5 64.5h8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M53 42H18a1 1 0 0 1-1-1V30c0-5.523 4.477-10 10-10h26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M53 20c5.523 0 10 4.477 10 10v11a1 1 0 0 1-1 1H44a1 1 0 0 1-1-1V30c0-5.523 4.477-10 10-10z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 24.5,
    r: 1.5,
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M38.5 22.5v-5M31 12h9v5h-9z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    x: 21,
    y: 35,
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgEmptyInbox);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img-empty-inbox.817e83e474fe3d7824ee3db3d8aa7064.svg";